
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// A first-of-its-kind digital platform designed to solve daily challenges faced by Society Managing Committee. 

const images = [
  "/assets/img/HT_Scty_Prob1.png",
  "/assets/img/HT_Scty_Prob2.png",
  //  "/assets/img/HT_Scty_Prob3.png",
  "/assets/img/HT_Scty_Prob4.png",
  // "/assets/img/HT_Scty_Problem.png",
];

/// Start Maintenance Computation

const mc_images = [
  "/assets/img/Prod_Carousel/maint_comp1.png",
  "/assets/img/Prod_Carousel/maint_comp2.png",
];

function ImageCarouselMaintCompt() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % mc_images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel fade-carousel">
      {mc_images.map((img, i) => (
        <img
          key={i}
          src={img}
          alt="Feature"
          className={`carousel-img ${i === index ? "active" : ""}`}
        />
      ))}
    </div>
  );
}

/// End Maintenance Computation

/// Start Commmunication with Members

const comm_mem_images = [
  "/assets/img/Prod_Carousel/comm_mobile1.png",
  "/assets/img/Prod_Carousel/comm_mobile2.png",
];

function ImageCarouselCommMembers() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % comm_mem_images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel fade-carousel">
      {comm_mem_images.map((img, i) => (
        <img
          key={i}
          src={img}
          alt="Feature"
          className={`carousel-img ${i === index ? "active" : ""}`}
        />
      ))}
    </div>
  );
}

/// End Commmunication with Members

/// Start Commmunication with Members

const tant_park_images = [
  "/assets/img/Prod_Carousel/tenant_parking1.png",
  "/assets/img/Prod_Carousel/tenant_parking2.png",
];

function ImageCarouselTenantPark() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % tant_park_images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel fade-carousel">
      {tant_park_images.map((img, i) => (
        <img
          key={i}
          src={img}
          alt="Feature"
          className={`carousel-img ${i === index ? "active" : ""}`}
        />
      ))}
    </div>
  );
}

/// End Commmunication with Members

/// Start Finance

const finance_images = [
  "/assets/img/Prod_Carousel/finance1.png",
  "/assets/img/Prod_Carousel/finance2.png",
];

function ImageCarouselFinance() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % finance_images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel fade-carousel">
      {finance_images.map((img, i) => (
        <img
          key={i}
          src={img}
          alt="Feature"
          className={`carousel-img ${i === index ? "active" : ""}`}
        />
      ))}
    </div>
  );
}

/// End Finance

/// Start Finance

const mob_app_images = [
  "/assets/img/Prod_Carousel/mob_app_feat1.png",
  "/assets/img/Prod_Carousel/mob_app_feat2.png",
  "/assets/img/Prod_Carousel/mob_app_feat3.png",
];

function ImageCarouselMobApp() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % mob_app_images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel fade-carousel">
      {mob_app_images.map((img, i) => (
        <img
          key={i}
          src={img}
          alt="Feature"
          className={`carousel-img ${i === index ? "active" : ""}`}
        />
      ))}
    </div>
  );
}

/// End Finance

const solution_images = [
  "/assets/img/HT_Solution1.png",
  "/assets/img/HT_Solution3.png",
  "/assets/img/HT_Solution4.png",
];

function ImageCarouselFade() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel fade-carousel">
      {images.map((img, i) => (
        <img
          key={i}
          src={img}
          alt="Feature"
          className={`carousel-img ${i === index ? "active" : ""}`}
        />
      ))}
    </div>
  );
}

function ImageCarouselSolution() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % solution_images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel fade-carousel">
      {solution_images.map((img, i) => (
        <img
          key={i}
          src={img}
          alt="Feature"
          className={`carousel-img ${i === index ? "active" : ""}`}
        />
      ))}
    </div>
  );
}

const feature_images1 = [
  "/assets/img/HT_Feature1.png",
  "/assets/img/HT_Feature2.png",
  "/assets/img/HT_Feature3.png",
];

function ImageCarouselFeature1() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % feature_images1.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel fade-carousel">
      {feature_images1.map((img, i) => (
        <img
          key={i}
          src={img}
          alt="Feature"
          className={`carousel-img ${i === index ? "active" : ""}`}
        />
      ))}
    </div>
  );
}

/// Slide Carousel

function ImageCarousel() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel slide-carousel">
      <div
        className="carousel-track"
        style={{ transform: `translateX(-${index * 100}%)` }}
      >
        {images.map((img, i) => (
          <img key={i} src={img} alt="Feature" />
        ))}
      </div>
    </div>
  );
}

const BookDemoButton = () => {
  const navigate = useNavigate();
  const [bgColor, setBgColor] = useState("#F3BD00");

  const buttonStyle = {
    backgroundColor: bgColor,
    color: bgColor === "#0C2B4B" ? "#ffffff" : "#0C2B4B",
    padding: "14px 32px",
    borderRadius: "150px",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "16px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
    transition: "all 0.3s ease",
    border: "none",
    margin: "10px"
  };

  return (
    <button
      style={buttonStyle}
      onClick={() => navigate("/bookademo?product=HabiTech")}
      onMouseEnter={() => setBgColor("#0C2B4B")}
      onMouseLeave={() => setBgColor("#F3BD00")}
    >
      Book a Demo
    </button>
  );
};
const HabiTech = () => {
 

  return (
    // <div
    //   style={{
    //     borderLeft: "150px solid  #0C2B4B",
    //     borderRight: "150px solid #0C2B4B",
    //   }}
    // >
    <div className="page-wrapper">
      <div className="product-page">
        {/* TOP BOOK A DEMO BUTTON */}
        {/* <div style={{ textAlign: "center", marginTop: "20px" }}>
          <BookDemoButton />
        </div> */}
        {/* Top Description */}
        <div className="product-header" style={{ textAlign: "center", padding: "20px 0 10px 0" }}>

          <h1 style={{ fontSize: "clamp(28px, 4vw, 40px)", color: "#0C2B4B", fontWeight: "600" }}>
            HabiTech – Smart Digital Management for Housing Societies
          </h1>

          <p
            style={{
              fontSize: "20px",
              marginTop: "20px",
              color: "#444",
              maxWidth: "900px",
              marginLeft: "auto",
              marginRight: "auto",
              lineHeight: "1.8"
            }}
          >
            A modern cloud-based platform designed to simplify housing society
            administration, automate maintenance collection and improve
            communication between managing committees and members.
          </p>

          <div style={{ marginTop: "25px" }}>
            <p style={{ fontSize: "17px", color: "#555" }}>
              ✔ Maintenance billing & collection automation
              &nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;&nbsp;
              ✔ Web Portal for Managing Committee
              &nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;&nbsp;&nbsp;<br />
              ✔ Mobile App for Members
              &nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;&nbsp;
              ✔ Secure Cloud Platform
            </p>
          </div>

          <p
            style={{
              marginTop: "20px",
              fontSize: "16px",
              color: "#666",
              maxWidth: "800px",
              marginLeft: "auto",
              marginRight: "auto"
            }}
          >
            Access your society management system anytime, anywhere with a
            seamless combination of a powerful web portal and a convenient
            mobile application.
          </p>
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <BookDemoButton />
          </div>

          {/* <hr
            style={{
              height: "4px",
              backgroundColor: "#0C2B4B",
              border: "none",
              marginTop: "30px"
            }}
          /> */}

          <hr
            style={{
              width: "70%",
              height: "4px",
              backgroundColor: "#0C2B4B",
              border: "none",
              margin: "40px auto"
            }}
          />

        </div>
        {/* End Top Description */}

        {/* Start Problem Section */}

        {/* <div style={{ padding: "20px 40px 40px 40px" }}> */}
        <div style={{ padding: "20px 20px 40px 20px" }}>

          <h2
            style={{
              color: "#C62828",
              fontWeight: "700",
              fontSize: "34px",
              textAlign: "center",
              marginBottom: "15px"
            }}
          >
            Problems Housing Societies Face Today
          </h2>

          <p
            style={{
              textAlign: "justify",
              textAlignLast: "left",
              fontSize: "18px",
              lineHeight: "1.7",
              color: "#555",
              maxWidth: "850px",
              margin: "0 auto 30px auto"
            }}
          >
            Managing a housing society often involves many manual and
            time-consuming tasks. Many societies still rely on paper registers,
            spreadsheets, and scattered communication channels.
          </p>

          <div className="row" style={{ margin: "0" }}>

            {/* <div className="col-md-8 mx-auto" > */}
            <div className="col-lg-8 col-md-10 col-12 mx-auto">
              {/* <ul style={{ fontSize: "17px", lineHeight: "2", paddingLeft: "80px" }}> */}
              <ul className="problem-list">
                <li>Manual maintenance collection and delayed payments</li>
                <li>Difficulty tracking tenants and parking allocations</li>
                <li>Paper notices and printed circulars</li>
                <li>Important messages lost in WhatsApp groups</li>
                <li>Complaints not properly tracked</li>
                <li>Financial records scattered across registers</li>
                <li>Limited transparency for members</li>
                <li>High workload for managing committee members</li>
              </ul>
            </div>

          </div>

        </div>
        {/* End Problem Section */}

        {/* <hr
          style={{
            width: "800px",
            height: "4px",
            backgroundColor: "#0C2B4B",
            border: "none",
            margin: "40px auto"
          }}
        /> */}

        <hr
            style={{
              width: "70%",
              height: "4px",
              backgroundColor: "#0C2B4B",
              border: "none",
              margin: "40px auto"
            }}
          />

        {/* Start How HabiTech Works Section */}

        {/* <div style={{ padding: "40px 40px 20px 40px", textAlign: "center" }}> */}
        <div style={{ padding: "40px 20px", textAlign: "center" }}>

          <h2 style={{
            color: "#0C2B4B",
            fontSize: "32px",
            fontWeight: "600",
            marginBottom: "30px"
          }}>
            How HabiTech Works in 3 Simple Steps
          </h2>

          <div className="row">

            {/* <div className="col-md-4"> */}
           <div className="col-lg-4 col-md-6 col-12">
              <div style={{ padding: "20px" }}>
                <h3 style={{ color: "#1A73E8" }}>1️⃣ Setup Your Society</h3>
                <p style={{ fontSize: "17px", lineHeight: "1.7", color: "#555" }}>
                  Create your society profile and import member details including flats,
                  owners, tenants, and parking information with a simple one-time setup.
                </p>
              </div>
            </div>

            {/* <div className="col-md-4"> */}
            <div className="col-lg-4 col-md-6 col-12">
              <div style={{ padding: "20px" }}>
                <h3 style={{ color: "#1A73E8" }}>2️⃣ Manage Society Operations</h3>
                <p style={{ fontSize: "17px", lineHeight: "1.7", color: "#555" }}>
                  Generate maintenance bills, track payments, send notices,
                  manage complaints, and maintain financial records using the
                  web portal.
                </p>
              </div>
            </div>

            {/* <div className="col-md-4"> */}
            <div className="col-lg-4 col-md-6 col-12">
              <div style={{ padding: "20px" }}>
                <h3 style={{ color: "#1A73E8" }}>3️⃣ Members Stay Connected</h3>
                <p style={{ fontSize: "17px", lineHeight: "1.7", color: "#555" }}>
                  Members use the mobile app to pay maintenance online, receive
                  notices, raise complaints, and stay updated with society
                  activities.
                </p>
              </div>
            </div>

          </div>

        </div>

        {/* End How HabiTech Works Section */}

        {/* <hr
          style={{
            width: "800px",
            height: "4px",
            backgroundColor: "#0C2B4B",
            border: "none",
            margin: "40px auto"
          }}
        /> */}

        <hr
            style={{
              width: "70%",
              height: "4px",
              backgroundColor: "#0C2B4B",
              border: "none",
              margin: "40px auto"
            }}
          />

        <div style={{ padding: "10px 40px 20px 40px", textAlign: "center" }}>

          <h2 style={{
            color: "#0C2B4B",
            fontSize: "32px",
            fontWeight: "600",
            marginBottom: "30px"
          }}>
            HabiTech Features at a Glance
          </h2>
        </div>

        <div className="feature-wrapper">

          {/* Feature Section 1 : Problem Statement */}
          {/* <div className="feature-row">
            <div className="feature-text">
              <h2>Still managing your society the hard way ?</h2>
              <p style={{ textAlign: "justify" }}>
                Tired of collecting maintenance manually? Still printing notices and registers?
                Too many WhatsApp messages and complaints?
              </p>
            </div>
            <div className="feature-image">
              <ImageCarouselFade />
            </div>
          </div> */}

          {/* Section 2 : Brief Solution (reversed)  757575 */}
          <div className="feature-row reverse">
            <div className="feature-text">
              {/* <h2 style={{ color: "#43A047" }}> There’s a simpler, smarter way to manage your Society. </h2> */}
              <h2 style={{ color: "#43A047", fontWeight: "600" }}>
                HabiTech provides a simpler, smarter way to manage your Society.
              </h2>
              <p style={{ textAlign: "justify" }}>
                Our cloud-based Solution replaces manual work with a centralized digital system for Managing Committees and Members.
                The platform works through two seamlessly connected components :</p> <br />
              <ul style={{ textAlign: "justify", paddingLeft: "20px" }}>
                <li> Web Portal for the Managing Committee.</li>
                <li>Mobile App for Society Members.</li>
              </ul>
            </div>
            <div className="feature-image">
              <ImageCarouselSolution />
            </div>
            {/* <div className="feature-image">
            <img src="/assets/img/HT_Scty_Problem.png" className="responsive-img" />
          </div> */}
          </div>

          <hr
            style={{
              width: "50%",
              borderTop: "2px dashed #0C2B4B",
              margin: "50px auto"
            }}
          />

          {/* Feature Section 3 : Web Portal Feature */}
          <div className="feature-row">
            <div className="feature-text">
              <h2 style={{ color: "#1A73E8" }}>Easy One Time Setup of Admin Data</h2>
              <p style={{ textAlign: "justify" }}>
                Define your Society Data with ease : </p><br />
              <ul style={{ textAlign: "justify", paddingLeft: "20px" }}>
                <li>Society Master</li>
                <li>Setup Discount or Penalty or Interest.</li>
                <li>Create or Import Members/Owners Data.</li>
              </ul>
            </div>
            <div className="feature-image">
              <ImageCarouselFeature1 />
              {/* <img src="/assets/img/HT_Scty_Prob2.png" className="responsive-img" /> */}
            </div>
          </div>

          <hr
            style={{
              width: "50%",
              borderTop: "2px dashed #0C2B4B",
              margin: "50px auto"
            }}
          />

          {/* Section 4 : Web Portal Feature (reversed)  */}
          <div className="feature-row reverse">
            <div className="feature-text">
              <h2 style={{ color: "#1A73E8" }}> Maintenance Computation </h2>
              <p style={{ textAlign: "justify" }}>
                Maintenance Computation are based on your defined parameters with Penalties or discounts :</p> <br />
              <ul style={{ textAlign: "justify", paddingLeft: "20px" }}>
                <li>System to compute late payment interest or penalties.</li>
                <li>Discount/Rebate on yearly maintenance.</li>
                <li>Maintenance structure can be changed in between the year.</li>
                <li>Offline maintenance can still be collected through chques/drafts.</li>
              </ul>
            </div>
            <div className="feature-image">
              <ImageCarouselMaintCompt />
              {/* <img src="/assets/img/HT_Scty_Problem.png" className="responsive-img" /> */}
            </div>
          </div>

          <hr
            style={{
              width: "50%",
              borderTop: "2px dashed #0C2B4B",
              margin: "50px auto"
            }}
          />
 
          {/* Feature Section 5 : Web Portal Feature */}
          <div className="feature-row">
            <div className="feature-text">
              <h2 style={{ color: "#1A73E8" }}>Manage Tenants and Parkings</h2>
              <p style={{ textAlign: "justify" }}>
                Define sublet charges for rented properties. Allocation of Parking : </p><br />
              <ul style={{ textAlign: "justify", paddingLeft: "20px" }}>
                <li>Define sublet charges.</li>
                <li>Allocate/Deallocate parking slots to Owners.</li>
              </ul>
            </div>
            <div className="feature-image">
              <ImageCarouselTenantPark />
              {/* <img src="/assets/img/HT_Scty_Prob2.png" className="responsive-img" /> */}
            </div>
          </div>

          <hr
            style={{
              width: "50%",
              borderTop: "2px dashed #0C2B4B",
              margin: "50px auto"
            }}
          />
 
          {/* Section 6 : Web Portal Feature (reversed)  */}
          <div className="feature-row reverse">
            <div className="feature-text">
              <h2 style={{ color: "#1A73E8" }}> Communicating with Mobile Paltform </h2>
              <p style={{ textAlign: "justify" }}>
                Managing Committee to use Web Portal to communicate with Members. No need to type the Notices, just speak the notice and it will be written. :</p> <br />
              <ul style={{ textAlign: "justify", paddingLeft: "20px" }}>
                <li>General Notices can be sent.</li>
                <li>AGM/SGM/MOM to be sent.</li>
                <li>Send Notice/Message to individual Member.</li>
                <li>Reply to Members Complaints/Request, raised online.</li>
              </ul>
            </div>
            <div className="feature-image">
              <ImageCarouselCommMembers/>
              {/* <img src="/assets/img/HT_Scty_Problem.png" className="responsive-img" /> */}
            </div>
          </div>

          <hr
            style={{
              width: "50%",
              borderTop: "2px dashed #0C2B4B",
              margin: "50px auto"
            }}
          />
 
          {/* Feature Section 7 : Web Portal Feature */}
          <div className="feature-row">
            <div className="feature-text">
              <h2 style={{ color: "#1A73E8" }}>Finance</h2>
              <p style={{ textAlign: "justify" }}>
                Easy to use Finance features, saves voucher entry efforts: </p><br />
              <ul style={{ paddingLeft: "20px" }}>
                <li>Auto Receipt Voucher posting in Finance.</li>
                <li>Budget Allocation.</li>
                <li>All Finance Reports.</li>
              </ul>
            </div>
            <div className="feature-image">
              <ImageCarouselFinance />
              {/* <img src="/assets/img/HT_Scty_Prob2.png" className="responsive-img" /> */}
            </div>
          </div>

          <hr
            style={{
              width: "50%",
              borderTop: "2px dashed #0C2B4B",
              margin: "50px auto"
            }}
          />
 
          {/* Section 8 : Brief Solution (reversed)  757575 */}
          <div className="feature-row reverse">
            <div className="feature-text">
              <h2 style={{ color: "#32CD32" }}> Mobile App For Members </h2>
              <p style={{ textAlign: "justify" }}>
                Easy to use Mobile App for Members, for greener environment :</p> <br />
              <ul style={{ textAlign: "justify", paddingLeft: "20px" }}>
                <li>Securely Maintenance Payment through any online payment mode.</li>
                <li>Maintenance Receipts are available online in pfd format, no receipt printing.</li>
                <li>Members can Read or Hear a Notice in multi languages.</li>
                <li>Notice alerta on the App.</li>
                <li>Members can raise Complaints/Suggestion/Request.</li>
                <li>Members can Like/dislike other Members' Suggestion.</li>
              </ul>
            </div>
            <div className="feature-image">
              <ImageCarouselMobApp />
            </div>
          </div>
          {/* BOTTOM BOOK A DEMO BUTTON */}
          {/* BOTTOM BOOK A DEMO BUTTON */}
          <div style={{ textAlign: "center", margin: "40px 0" }}>
            <BookDemoButton />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HabiTech;
